module.exports = __webpack_public_path__ + "static/twitter-c8e40a46a878e4ac57c39d2978018c7b.png";